import { formatAsPrice } from '@/fsd/shared/lib/helpers/formatAsPrice/formatAsPrice';
import { sanitizeToNumericString } from '@/fsd/shared/lib/helpers/sanitizeToNumericString/sanitizeToNumericString';
import { useCallback } from 'react';

interface IPrams {
  sum: string;
  count: number;
  count_fact: number;
  edit: (value: string, id: number, column: string) => void;
}

export const useProductsSum = ({ sum, count, count_fact, edit }: IPrams) => {
  const setSum = useCallback(
    (value: string, id: number) => edit(value, id, 'sum'),
    [edit]
  );

  const editSum = (value: string, id: number, column: string) => {
    setSum(formatAsPrice(value), id);
    edit(formatAsPrice(value), id, 'sum');


    let newPrice;
    if (count) {
      if (!count || Number(count) === 0) return;
      else newPrice = sanitizeToNumericString(value) / count;
    } else {
      if (!count_fact || Number(count_fact) === 0) return;
      else newPrice = sanitizeToNumericString(value) / count_fact;
    }

    console.log(
      'editSum',
      'newPrice',
      newPrice,
      'formatAsPrice(0)',
      formatAsPrice(0)
    );

    edit(String(newPrice), id, 'price');
  };

  return { sum, setSum, editSum };
};
